const formatNegativeAmount = {
  filters: {
    formatNegativeAmount(value) {
      if (value) {
        if (value.toString().charAt(0) === '-') {
          return `(${value.slice(1)})`;
        }
        return value;
      }
      return null;
    },
  },
};

export default formatNegativeAmount;



// WEBPACK FOOTER //
// ./src/mixins/formatNegativeAmount.js